import React from "react";

interface TranslatableTextProps {
  text?: string | null;
  fallback?: string;
  className?: string;
}

/**
 * Frontend-only dynamic text wrapper.
 * Keeps source language metadata so browser/page translation can translate content.
 */
const TranslatableText: React.FC<TranslatableTextProps> = ({
  text,
  fallback = "",
  className,
}) => {
  const value = (text || "").trim() || fallback;
  return (
    <span className={className} lang="en" translate="yes" dir="auto">
      {value}
    </span>
  );
};

export default TranslatableText;
